<template>
  <div class="userFilter">
    <div class="statusFilter">
      <div class="userFilterInstructions">Show Users By Status</div>
      <status-filter />
    </div>
    <form @submit.prevent="onSubmit">
      <div class="userFilterInstructions">Filter By Name or Email</div>
      <div class="userChoices">
        <select v-model="category" @change="clearInput()">
          <option value="name">Name</option>
          <option value="email">Email</option>
        </select>
        <div v-show="category === 'name'">
          <div class="userInput">
            <Input class="nameInput" :placeholder="'First Name'" v-model="firstName"  />
            <Input class="nameInput" :placeholder="'Last Name'" v-model="lastName"  />
            <Button
              :button-type="'submit'"
              :button-style="'auto'"
              class="nameSearchButton"
              ><span class="wk-icon-search"
            /></Button>
          </div>
        </div>
        <div v-show="category === 'email'">
          <div class="userInput">
            <Input class="emailInput" :placeholder="'Email'" v-model="email"  />
            <Button
              :button-type="'submit'"
              :button-style="'auto'"
              class="emailSearchButton"
              ><span class="wk-icon-search"
            /></Button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  SET_FIRSTNAME_SEARCH,
  SET_LASTNAME_SEARCH,
  SET_EMAIL_SEARCH,
  SET_ERROR_STATE,
} from "../../store/manage.store";
import {
    RESPONSE_STATUSES,
    MODAL_MESSAGE
} from '../shared/constants'
import { mapActions, mapMutations, mapGetters } from "vuex";
import Input from "../shared/Input.vue";
import Button from "../shared/Button.vue";
import StatusFilter from "./StatusFilter.vue";

export default {
  components: { Input, Button, StatusFilter },
  data() {
    return {
      category: "name",
      firstName: "",
      lastName: "",
      email: "",
    };
  },

  computed: mapGetters ([
		'authToken',
	]),

  beforeDestroy() {
    this.$root.$off("selectionChanged");
  },  

  methods: {
    ...mapMutations([
      SET_FIRSTNAME_SEARCH,
      SET_LASTNAME_SEARCH,
      SET_EMAIL_SEARCH,
      SET_ERROR_STATE,
    ]),

    ...mapActions([
			"getFilteredUsers", 
			"showModal", 
			"logoutUser"
		]),

    clearInput() {
      this.firstName = "";
      this.lastName = "";
      this.email = "";
    },

    async onSubmit() {
      this[SET_FIRSTNAME_SEARCH]("");
      this[SET_LASTNAME_SEARCH]("");
      this[SET_EMAIL_SEARCH]("");
      if (this.category === "name") {
        this[SET_FIRSTNAME_SEARCH](this.firstName);
        this[SET_LASTNAME_SEARCH](this.lastName);
      } else {
        this[SET_EMAIL_SEARCH](this.email);
      }

      try {
        await this.getFilteredUsers();
        this.$root.$emit("selectionChanged");
      } catch (error) {
        if (
          error === RESPONSE_STATUSES.AUTHENTICATION_FAILED ||
          error === RESPONSE_STATUSES.AUTHORIZATION_FAILED
        ) {
          this.logoutUser();
        } else {
          this.showModal(MODAL_MESSAGE.ERROR("Search action"));
        }
      }
    },
  },
};
</script>

<style lang="scss">
.userChoices {
  display: flex;
  flex-wrap: wrap;
  select,
  Input,
  Button {
    height: 32px;
    font-size: 14px;
    box-sizing: content-box;
    padding-top: 0;
    padding-bottom: 0;   
  }

  select,
  Input {
    width: 196px;
    border: 1px solid $WK-GRAY-TINT3;
    background-color: $WK-WHITE;
    padding-left: 8px;
    padding-right: 2px;
  }

  Button {
    width: 32px;
    padding: 0;
  }

  .emailInput {
    width: 391px;
    @media only screen and (max-width: 600px) {
      width: 196px;
    }
  }
}

.userFilterInstructions {
  font-family: "Noto Sans Light", sans-serif;
  margin-bottom: 5px;
}

.userInput {
  display: flex;
  flex-wrap: wrap;
}

.wk-icon-search {
  border-radius: 0;
}

.statusFilter {
  padding-bottom: 17px;
}
</style>